import { ExchangeService } from "@gen/travel/v1/exchange_pb";
import { client } from "./config";
import { timestampFromDate } from "@bufbuild/protobuf/wkt";
import { DateType } from "@gen/travel/v1/search_pb";
import { SearchDate } from "./travel";

export async function searchExchange(
  travelId: string,
  journeyId: string,
  date: SearchDate,
) {
  return await client(ExchangeService).search({
    travelId,
    journeyId,
    date: {
      date: timestampFromDate(date.date),
      type: date.type == "arrival" ? DateType.ARRIVAL : DateType.DEPARTURE,
    },
  });
}

export async function confirmExchange(
  travelId: string,
  journeyId: string,
  offerId: string,
) {
  return await client(ExchangeService).confirm({
    travelId,
    journeyId,
    offerId,
  });
}
